import React, { useCallback } from 'react';

import { useField } from 'formik';

import { IRadioSelectProps } from 'components/Controls/RadioSelect';
import { ErrorMessage } from 'components/Form/ErrorMessage';
import { appReactMemo } from 'hocs';

import RadioSelect from '../../Controls/RadioSelect';

const FormikRadioSelect = ({ name, onChange, ...rest }: IRadioSelectProps) => {
  const [field, meta, helpers] = useField(name || '');

  const onValueChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, value: unknown) => {
      helpers.setValue(value, false);
      helpers.setError(undefined);
      onChange?.(e, value);
    },
    [onChange, helpers],
  );

  return (
    <>
      <RadioSelect
        {...rest}
        name={name}
        onChange={onValueChange}
        value={field.value?.toString()}
      />
      {meta.touched && meta.error && <ErrorMessage>{meta.error}</ErrorMessage>}
    </>
  );
};

export default appReactMemo(FormikRadioSelect);
